import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";

// شبكة سطور الاستلام — رأس وصفوف بنفس القالب والحشوة تماماً لضمان التطابق العمودي.
// ديسكتوب: 4 أعمدة. موبايل: بطاقات مكدّسة مع تسميات جانبية.
const ROW = "grid gap-2 md:gap-3 md:grid-cols-[minmax(0,1fr)_110px_110px_150px] md:items-center md:px-3 md:py-2";

export const ReceiveLinesGrid = ({ lines, qtys, setQtys, disabled }) => {
  const { t } = useTranslation();
  const label = (k) => t(`warehouse.${k}`);

  const MobileLabel = ({ k }) => (
    <span className="md:hidden text-[10px] font-bold uppercase text-muted-foreground">
      {label(k)}
    </span>
  );

  return (
    <div className="grid gap-2 md:gap-0" data-testid="wh-lines-grid">
      <div className={`hidden md:grid border-b border-border/40 ${ROW}`}>
        <div className="text-[11px] font-bold text-muted-foreground text-start">{label("item")}</div>
        <div className="text-[11px] font-bold text-muted-foreground text-center">{label("ordered")}</div>
        <div className="text-[11px] font-bold text-muted-foreground text-center">{label("received")}</div>
        <div className="text-[11px] font-bold text-muted-foreground text-center">{label("receivingNow")}</div>
      </div>
      {(lines || []).map((l) => (
        <div key={l.line_no}
             data-testid={`wh-line-${l.line_no}`}
             className={`rounded-2xl bg-background/40 p-3 shadow-neu-in md:bg-transparent md:shadow-none md:rounded-none md:border-t md:border-border/40 md:p-0 ${ROW}`}>
          <div className="min-w-0 flex items-center justify-between md:justify-start md:block">
            <MobileLabel k="item" />
            <p className="truncate text-sm font-semibold text-start">
              {l.description || l.description_ar}
            </p>
          </div>
          <div className="flex items-center justify-between md:justify-center">
            <MobileLabel k="ordered" />
            <span className="num font-mono text-sm">{l.quantity}</span>
          </div>
          <div className="flex items-center justify-between md:justify-center">
            <MobileLabel k="received" />
            <span className="num font-mono text-sm text-muted-foreground">
              {l.received_quantity || 0}
            </span>
          </div>
          <div className="flex items-center justify-between gap-2 md:justify-center">
            <MobileLabel k="receivingNow" />
            <NeuInput dir="ltr" className="h-10 w-24 text-center" disabled={disabled}
                      data-testid={`wh-qty-${l.line_no}`}
                      value={qtys[l.line_no] ?? l.remaining_quantity}
                      onChange={(e) => setQtys({ ...qtys, [l.line_no]: e.target.value })} />
          </div>
        </div>
      ))}
    </div>
  );
};
